// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aR4u","footer":"styles_footer__REECn"};